var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"groups-container"},[_c('b-row',{attrs:{"align-v":"start"}},_vm._l((_vm.groups),function(group){return _c('b-col',{key:group.id,staticClass:"mb-3",attrs:{"cols":"12","lg":"12","md":"12","sm":"12","xs":"12"}},[_c('ul',{staticClass:"list-unstyled"},[_c('MembersMedia',{attrs:{"group":group}})],1)])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70eb086f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/groups/MembersList.vue
// module id = null
// module chunks = 